import MassegeIcon from "../../Images/massege.svg";
import ShareIcon from "../../Images/Share.png";
import StarIcon from "../../Images/Star.svg";
import StarHalfIcon from "../../Images/StarHalf.svg";
import StarFreeIcon from "../../Images/StarFree.svg";
import FaceIcon from "../../Images/facebook.png";
import Rating from "react-rating";
import { useState } from "react";
import { useTranslation } from "react-i18next";

function BrandName({ product }) {
  const [showSharing, setShowSharing] = useState(false);
  const {i18n, t} = useTranslation();
  const handleEmailShare = () => {
    const subject = encodeURIComponent(
      `Check out this product: ${product?.product?.name}`
    );
    const body = encodeURIComponent(
      `Hi, I found this product and thought you might like it: ${window.location.href}`
    );
    window.location.href = `mailto:?subject=${subject}&body=${body}`;
  };

  const handleFacebookShare = () => {
    const url = encodeURIComponent(window.location.href);
    const facebookShareUrl = `https://www.facebook.com/sharer/sharer.php?u=${url}`;
    window.open(facebookShareUrl, "_blank");
  };

  const handleCopyLink = () => {
    navigator.clipboard
      .writeText(window.location.href)
      .then(() => {
        alert("Link copied to clipboard!");
      })
      .catch((err) => {
        console.error("Failed to copy: ", err);
      });
  };



  return (
    <div className="brand-name d-flex justify-content-between">
      <div className="">
     
          <h2 className="m-0 p-0">{product?.product?.brand?.name}</h2>
       
        <p className="m-0 p-0">{i18n.language == 'ar' ? product?.product?.name_ar : product?.product?.name}</p>
        <div className="product-rating d-flex gap-2 align-items-center flex-grow-1 m-0  p-0 w-100">
          {/* <p>{product?.totalRate?.toFixed(2)}</p>
          <div className="d-flex gap-2 flex-row-reverse">
            <Rating
              initialRating={product?.totalRate}
              readonly
              emptySymbol={<img src={StarFreeIcon} alt="" className="star" />}
              placeholderSymbol={
                <img src={StarHalfIcon} alt="" className="star" />
              }
              fullSymbol={<img src={StarIcon} alt="" className="star" />}
            />
          </div> */}
          {/* <img src={MassegeIcon} alt="" className="massege-icon me-4" />
          <p className="rate-num">{product?.rates?.length} تقييم</p> */}
        </div>
      </div>
      <div className="sharing-container">
        <img
          src={ShareIcon}
          width={40}
          height={40}
          alt=""
          onClick={() => setShowSharing(!showSharing)}
          className="sharing align-self-start"
        />
        {showSharing && (
          <>
            <ul>
              <li onClick={handleEmailShare}>
                {messageIcon} {t("email")}
              </li>
              <li onClick={handleFacebookShare}>
                <img src={FaceIcon} alt="" /> {t("Facebook")}
              </li>
              <li onClick={handleCopyLink}>{copyIcon}  {t("Copy Link")}</li>
            </ul>
            <div className="arrow"></div>
          </>
        )}
      </div>
    </div>
  );
}
export default BrandName;

const messageIcon = (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_1606_5169)">
      <path
        d="M19.25 0.916992H2.75C2.02065 0.916992 1.32118 1.20672 0.805456 1.72245C0.289731 2.23817 0 2.93765 0 3.66699L0 21.0837H22V3.66699C22 2.93765 21.7103 2.23817 21.1945 1.72245C20.6788 1.20672 19.9793 0.916992 19.25 0.916992ZM2.75 2.75033H19.25C19.4931 2.75033 19.7263 2.8469 19.8982 3.01881C20.0701 3.19072 20.1667 3.42388 20.1667 3.66699V4.27841L12.9452 11.5008C12.4286 12.0154 11.7291 12.3043 11 12.3043C10.2709 12.3043 9.57144 12.0154 9.05483 11.5008L1.83333 4.27841V3.66699C1.83333 3.42388 1.92991 3.19072 2.10182 3.01881C2.27373 2.8469 2.50688 2.75033 2.75 2.75033ZM1.83333 19.2503V6.87533L7.75867 12.797C8.61908 13.6552 9.78474 14.1372 11 14.1372C12.2153 14.1372 13.3809 13.6552 14.2413 12.797L20.1667 6.87533V19.2503H1.83333Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="clip0_1606_5169">
        <rect width="22" height="22" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
const copyIcon = (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_1606_5180)">
      <path
        d="M9.70043 18.819C8.83228 19.6639 7.66636 20.1331 6.45493 20.125C5.24349 20.1169 4.08397 19.6321 3.22721 18.7756C2.37046 17.9191 1.88538 16.7597 1.87692 15.5483C1.86846 14.3369 2.33731 13.1708 3.18201 12.3024L7.08885 8.39284L5.79176 7.09668L1.88585 11.0063C0.67793 12.2148 -0.000429579 13.8536 2.04097e-07 15.5623C0.000429988 17.271 0.679614 18.9095 1.88814 20.1174C3.09666 21.3254 4.73554 22.0037 6.44422 22.0033C8.1529 22.0029 9.79143 21.3237 10.9993 20.1152L14.9062 16.2083L13.61 14.9122L9.70043 18.819Z"
        fill="black"
      />
      <path
        d="M20.1141 1.88976C19.5176 1.28917 18.8078 0.812933 18.026 0.488632C17.2441 0.164332 16.4056 -0.00158014 15.5592 0.000510869C14.7131 -0.00173655 13.8751 0.163749 13.0934 0.4874C12.3117 0.81105 11.602 1.28644 11.0052 1.88609L7.09375 5.79384L8.38992 7.09093L12.2995 3.18409C12.7263 2.75477 13.2339 2.41437 13.7931 2.1826C14.3524 1.95083 14.952 1.83229 15.5573 1.83384C16.4687 1.83415 17.3596 2.10466 18.1173 2.61118C18.875 3.1177 19.4655 3.83749 19.8142 4.67956C20.1629 5.52163 20.2541 6.44818 20.0762 7.34207C19.8984 8.23596 19.4596 9.05707 18.8152 9.70159L14.9083 13.6084L16.2054 14.9055L20.1123 11.0005C21.3186 9.79152 21.9963 8.15344 21.9966 6.44551C21.997 4.73759 21.32 3.09924 20.1141 1.88976Z"
        fill="black"
      />
      <path
        d="M13.606 7.09661L7.09375 13.6089L8.39011 14.9052L14.9024 8.39297L13.606 7.09661Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="clip0_1606_5180">
        <rect width="22" height="22" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
